exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#editingPopup[data-v-a3103a68] {\n  position: absolute;\n\n  font-size: 20px;\n  margin: 0px 5px 0px;\n  box-sizing: border-box;\n  background-color: white;\n  border-color: #ffd500;\n  border-style: solid;\n  border-radius: 5px;\n  padding-top: 5px;\n  z-index: 999;\n}\n#message[data-v-a3103a68] {\n  width: 90%;\n}\n#editingForm[data-v-a3103a68] {\n  text-align: left;\n  padding: 10px 10px 5px 10px;\n  margin: auto;\n}\n#eraseButton[data-v-a3103a68] {\n  color: #ff6666;\n}\n.closeButton[data-v-a3103a68] {\n  float: right;\n  border: none;\n  color: white;\n  margin-right: 5px;\n  background-color: #ffd500;\n}\n.closeButton[data-v-a3103a68]:hover {\n  opacity: 0.5;\n}\n.errorDuplication[data-v-a3103a68] { /* 同一ユーザーの同一時間での予約の重複がある */\n  background-color: #ffcccc;\n}\n.dialog[data-v-a3103a68] {\n  text-align: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a3103a68","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/EditingPopup.vue
// module id = 541
// module chunks = 0